import FileSaver from 'file-saver';

export function timeout() {
    return new Promise(res => setTimeout(res, (Math.random() * (10000 - 2000) + 2000)));
}

export const download_file = async (file_name) => {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;
    console.log(file_name)
    try {
        await fetch(apiServer + 'api/file/files_download/' + file_name).then(function (response) {
            return response.blob()
        }).then(function (blob) {
            FileSaver.saveAs(blob, file_name)
        });

        const myDelete = await fetch(apiServer + 'api/file/files_delete/' + file_name, {method: 'DELETE'});
        const deleteResponse = await myDelete.json();
        console.log(deleteResponse);
    } catch (e) {
        console.log(e)
    }
}